import React from 'react';
import { Button, Icon, Form, Header, Segment, Loader, Table, Grid, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { toast } from 'react-toastify';
import download from 'downloadjs';
import ReactExport from 'react-data-export';
import ReportExcelFile from '../StudentService/StudentsReports/ReportExcelFile';

import { fetchAcademicYears, fetchEmployeeTypes, fetchFaculties } from '../Lookups/util';
import { extractFileNameFromHeaders } from '../DegreeDocumentPrint/util/util';
import SearchTableData from '../util/SearchTableData';
import PaginationFront from "../util/PaginationFront";
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class WorkloadReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            academicYearId: null,
            organizationalUnitId: null,
            employeeId: null,
            employees: [],
            organizationalUnits: [],

            data: [],
            excelData: [],

            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            clicked: false,


            unsa: localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja' || localStorage.getItem('activeRole').substr(0, 13) === 'Administrator',

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getReport = this.getReport.bind(this);
        this.getEmployees = this.getEmployees.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties()])
            .then(axios.spread((orgUnitsRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet');

                this.setState({
                    organizationalUnits
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });

        if (!this.state.unsa) this.getEmployees();
    }

    getEmployees(organizationalUnitId) {
        let obj = {};
        if (this.state.unsa) {
            obj = {
                organizationalUnitId
            };
        } else {
            obj = {};
        }


        axios.post('employees/by-organizational-unit', { ...obj })
            .then(res => {
                this.setState({
                    employees: res.data.filter(e => e.employeeTypeId === this.props.employeeTypeId).map(el => ({
                        ...el, text: el.employeeLastName + ' ' + el.employeeFirstName, value: el.employeeId, key: el.employeeId
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch (all) employees');
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'organizationalUnitId') {
            this.getEmployees(value);
        }
        this.setState({
            [name]: value
        });
    }

    getReport(employeeId) {
        this.setState({clicked: true});
        if (employeeId) {
            let obj = {
                employeeId,
                academicYearId: this.state.academicYearId,
                language: 'bs'
            };
            axios({
                method: 'post',
                url: '/documents/employee-workload-report',
                responseType: 'blob',
                data: { ...obj }
            })
                .then(res => {
                    if (res.data.size === 0) {
                        this.setState({clicked: false});
                        return;
                    }
                    const fileName = extractFileNameFromHeaders(res.headers);
                    download(res.data, fileName);
                    this.setState({clicked: false});
                    return res;


                })
                .catch(err => {
                    toast('Došlo je do greške! Zahtjev nije obrađen.');
                });
        } else {
            let obj = {};

            if (this.state.unsa) {
                obj = {
                    organizationalUnitId: this.state.organizationalUnitId,
                    academicYearId: this.state.academicYearId,
                    language: 'bs'
                };
            } else {
                obj = {
                    academicYearId: this.state.academicYearId,
                    language: 'bs'
                };
            }

            axios({
                method: 'post',
                url: '/documents/ou-workload-report',
                responseType: 'blob',
                data: { ...obj }
            })
                .then(res => {
                    if (res.data.size === 0) {
                        this.setState({clicked: false});
                        return;
                    }
                    const fileName = extractFileNameFromHeaders(res.headers);
                    download(res.data, fileName);
                    this.setState({clicked: false});
                    return res;
                })
                .catch(err => {
                    toast('Došlo je do greške! Zahtjev nije obrađen.');
                });
        }
    }


    filter() {
        if (!this.state.academicYearId || (this.state.unsa && !this.state.organizationalUnitId)) {
            toast('Odaberite akademsku godinu i organizacionu jedinicu.');
            return;
        }
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {
        };

        axios.get(`course-workload/ou-workload-report/${this.state.unsa ? this.state.organizationalUnitId : 0}/${this.state.academicYearId}`)
            .then(res => {

                let assistants = res.data.ouAssistantWorkloadReportDTOS.map(el=>({...el, role: 'asistent'}))
                let professors = res.data.ouProfessorWorkloadReportDTOS.map(el=>({...el, role: 'profesor'}))
                let data = [ ...professors, ...assistants];
                this.setState({
                    data,
                    loaded: true,
                    excelData: data.map(el => ([
                        { value: el.employeeName},
                        { value: el.role},
                        { value: el.lectureNumber},
                        { value: el.exerciseNumber},
                        { value: el.bp},
                        { value: el.kdp},
                        { value: el.workloadCoefficient},
                    ]))
                });
            });
    }

    getResults(results) {
        if(results.length === 0){
            this.setState({
                excelData:  this.state.data.map(el => ([
                    { value: el.employeeName},
                    { value: el.role},
                    { value: el.lectureNumber},
                    { value: el.exerciseNumber},
                    { value: el.bp},
                    { value: el.kdp},
                    { value: el.workloadCoefficient},
                ]))});
        }else{
            this.setState({ results,
                excelData:  results.map(el => ([
                    { value: el.employeeName},
                    { value: el.role},
                    { value: el.lectureNumber},
                    { value: el.exerciseNumber},
                    { value: el.bp},
                    { value: el.kdp},
                    { value: el.workloadCoefficient},
                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime i ime', width: { wpx: 200 } },
                    { title: 'Uloga', width: { wpx: 150 } },
                    { title: 'Broj predavanja', width: { wpx: 150 } },
                    { title: 'Broj vježbi', width: { wpx: 150 } },
                    { title: 'Broj sati preko nastavnog opterećenja', width: { wpx: 150 } },
                    { title: 'Koeficijent za rad preko nastavne norme', width: { wpx: 150 } },
                    { title: 'Koeficijent opterećenja', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (
            <div>

                <Form>
                    <Form.Group widths="equal">


                        <Form.Field required>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYearId}
                                onChange={this.handleInputChange}
                                name="academicYearId"
                                options={this.props.academicYears}
                                search
                            />
                        </Form.Field>

                        {this.state.unsa && <Form.Field required>
                            <label>Organizaciona jedinica</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite organizacionu jedinicu"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.state.organizationalUnits}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>}
                        {/*{this.props.employees && <Form.Field>*/}
                        {/*    <label>Nastavnik / saradnik</label>*/}
                        {/*    <Form.Dropdown*/}
                        {/*        clearable*/}
                        {/*        placeholder="Odaberite nastavnika / asistenta"*/}
                        {/*        value={this.state.employeeId}*/}
                        {/*        onChange={this.handleInputChange}*/}
                        {/*        name="employeeId"*/}
                        {/*        options={this.state.employees.filter(el => el.main)}*/}
                        {/*        search*/}
                        {/*        fluid*/}
                        {/*        selection*/}
                        {/*    />*/}

                        {/*</Form.Field>}*/}

                    </Form.Group>

                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Filtriraj</Button>

                </Form>

                <br /><br /><br />

                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.data.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={8}>
                                        <Grid column={2} stackable>
                                            <Grid.Column width={12}>
                                                <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['role', 'employeeName', 'bp', 'exerciseNumber', 'kdp', 'workloadCoefficient']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} style={{ paddingRight: '5px' }}>
                                                {this.state.clicked ? <Button
                                                    basic
                                                    fluid
                                                    size="small"
                                                    color="red"
                                                >
                                                    <Button.Content hidden></Button.Content>
                                                    <Button.Content visible>
                                                        <Loader active size="mini" />
                                                        &nbsp;
                                                    </Button.Content>
                                                </Button>
                                                :<Popup
                                                    trigger={
                                                        <Button
                                                            animated="vertical"
                                                            fluid
                                                            color="red"
                                                            basic
                                                            onClick={()=>this.getReport(false)}
                                                        >
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                PDF
                                                            </Button.Content>
                                                        </Button>
                                                    }
                                                    content="Preuzmi spisak za cijelu organizacionu jedinicu u PDF-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                                }

                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile
                                                    filename="Nastavno opterećenje"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Nastavno opterećenje" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell >Prezime i ime</Table.HeaderCell>
                                    <Table.HeaderCell >Uloga</Table.HeaderCell>
                                    <Table.HeaderCell > Broj predavanja</Table.HeaderCell>
                                    <Table.HeaderCell > Broj vježbi</Table.HeaderCell>
                                    <Table.HeaderCell > Broj sati preko nastavnog opterećenja</Table.HeaderCell>
                                    <Table.HeaderCell > Koeficijent za rad preko nastavne norme</Table.HeaderCell>
                                    <Table.HeaderCell > Koeficijent opterećenja</Table.HeaderCell>
                                    <Table.HeaderCell > </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle" > {el.employeeName}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.role}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.lectureNumber ? el.lectureNumber : 0}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.exerciseNumber}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.bp}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.kdp}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.workloadCoefficient}</Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle" > <Popup
                                        trigger={
                                            <Icon
                                                link
                                                animated="vertical"
                                                fluid
                                                color="red"
                                                basic
                                                circular
                                                name="download"
                                                onClick={()=>this.getReport(el.employeeId)}
                                            >
                                            </Icon>
                                        }
                                        content="Preuzmi pojedinačni spisak u PDF-u"
                                        hideOnScroll
                                        position="top center"
                                    /></Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                    </div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/WorkloadReport.js